/**
 * MyClips V3 — Share helper
 *
 * Tries the native Web Share API (iOS Safari, modern Android Chrome),
 * falls back to copy-to-clipboard, and as a last resort prompts the user.
 *
 * L-16: Share URL `/c/:clipId` (MyClips V3 deep link). Firebase Hosting
 * rewrite `/c/** → renderClipShare` Cloud Function → OG meta tags +
 * klip için SEO landing. SPA içi navigation useClipDeepLink hook'u
 * ile yakalanır (mlv3:anchor-clip event).
 *
 * Eski `/clip/:id` pattern'i PermalinkPage ile V1/V2 clips için korur;
 * V3 klipleri `/c/:id` altında kanonik.
 */

import { buildClipUrl } from "../deeplink";

import { hataAlani } from "../../utils/hataAlani";
export const SHARE_RESULT = {
  SHARED: "shared",
  COPIED: "copied",
  CANCELLED: "cancelled",
  FAILED: "failed",
};

export async function shareClipV3({ clipId, caption = "", authorName = "" }: { clipId?: any; caption?: any; authorName?: any } = {}) {
  if (!clipId) return { result: SHARE_RESULT.FAILED, reason: "no_clip_id" };
  const url = buildClipUrl(clipId);
  const title = authorName ? `@${authorName} · MyClips` : "MyClips";
  const text = caption?.trim()
    ? `${caption.trim().slice(0, 140)}${caption.length > 140 ? "…" : ""}`
    : "MyClips'ten bir clip";

  // Web Share API
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({ title, text, url });
      return { result: SHARE_RESULT.SHARED, url };
    } catch (err) {
      if (hataAlani(err, "name") === "AbortError") {
        return { result: SHARE_RESULT.CANCELLED };
      }
      // fall through to clipboard
    }
  }

  // Clipboard fallback
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(url);
      return { result: SHARE_RESULT.COPIED, url };
    } catch (_) {
      // fall through
    }
  }

  // execCommand fallback — Android in-app WebView (FB/IG/TikTok) Clipboard
  // API'yi ve çoğu zaman window.prompt'u reddediyor → gizli textarea +
  // document.execCommand("copy") (AuthenticityProofSheet paterni).
  if (typeof document !== "undefined" && document.body) {
    try {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const done = document.execCommand("copy");
      document.body.removeChild(ta);
      if (done) {
        return { result: SHARE_RESULT.COPIED, url };
      }
    } catch (_) {
      // fall through
    }
  }

  // Prompt fallback
  try {
    window.prompt("Bağlantıyı kopyala:", url);
    return { result: SHARE_RESULT.COPIED, url };
  } catch (_) {
    return { result: SHARE_RESULT.FAILED };
  }
}

export default shareClipV3;
